const { hostname } = window.location;
let domain = 'shop.hachettebookgroup.com';
let storefrontAccessToken = 'fdf7a12aac6fc02a21b014e8b569ad8a';
let productId = 7655547470002;
if (hostname === 'hbg-develop.go-vip.co' || hostname === 'hbglocal.vipdev.lndo.site' || hostname === 'dev.novelsuspects.com') {
	domain = 'hbgusadev.myshopify.com';
	storefrontAccessToken = '47e8b2f8bcd90ed1007965c47234e5e6';
	productId = 8250823901359;
}

  // Map storefront hostnames to consistent values used for order attribution.
function getStorefrontValue() {
  const storefrontMap = {
    'hachettebookgroup.com': 'hachettebookgroup',
    'www.hachettebookgroup.com': 'hachettebookgroup',

    'jamespatterson.com': 'jamespatterson',
    'www.jamespatterson.com': 'jamespatterson',

    'elinhilderbrand.com': 'elinhilderbrand',
    'www.elinhilderbrand.com': 'elinhilderbrand',

    'readthewitcher.com': 'readthewitcher',
    'www.readthewitcher.com': 'readthewitcher',

    'davidbaldacci.com': 'davidbaldacci',
    'www.davidbaldacci.com': 'davidbaldacci',

    'orbitbooks.net': 'orbitbooks',
    'www.orbitbooks.net': 'orbitbooks',

    'novelsuspects.com': 'novelsuspects',
    'www.novelsuspects.com': 'novelsuspects',

    'brainquest.com': 'brainquest',
    'www.brainquest.com': 'brainquest',

    'moontravelguides.com': 'moon',
    'www.moontravelguides.com': 'moon',

    'thenovl.com': 'thenovl',
    'www.thenovl.com': 'thenovl',

    // Dev
    'hbg-develop.go-vip.co': 'hbgusadev',
  };

  return storefrontMap[hostname] || 'unattributed';
}
const freeShippingAmt = 40.00;
// send non HBG domains to respective shopify domain aliases
/* const hasShopAlias = ['novelsuspects.com', 'moontravelguides.com', 'thenovl.com'];
const domainWithoutWWW = hostname.replace(/^www\./, '');
if (hasShopAlias.includes(domainWithoutWWW)) {
  domain = `shop.${domainWithoutWWW}`;
} */

const addToCartIsbns = Object.entries(window).filter(([key]) => key.startsWith('addToCart_')); // eslint-disable-line max-len
let addToCartButton = {};
let buttonText = '';

window.__pendingATC = null;
  // Prevent repeated storefront attribute writes on cart re-renders.
window.__storefrontStamped = false;

// Utility to find .checkoutId from localStorage

function getCartGidFromLocalStorage() {

  for (let i = 0; i < localStorage.length; i++) {

    const key = localStorage.key(i);

    if (key && key.endsWith('.checkoutId')) {

      return localStorage.getItem(key);

    }

  }

  return null;

}

// Preserve existing cart attributes and add the originating storefront.
async function updateStorefrontCartAttribute(cartId) {
  const storefront = getStorefrontValue();

  const query = `
    query GetCartAttributes($cartId: ID!) {
      cart(id: $cartId) {
        attributes {
          key
          value
        }
      }
    }
  `;

  const mutation = `
    mutation UpdateCartAttributes($cartId: ID!, $attributes: [AttributeInput!]!) {
      cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
        cart {
          id
          attributes {
            key
            value
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  try {
    const readResponse = await fetch(`https://${domain}/api/2025-01/graphql.json`, {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables: { cartId },
      }),
    });

    const existingData = await readResponse.json();
    // Stop if existing attributes cannot be read to avoid overwriting cart data.
    if (existingData?.errors || !existingData?.data?.cart) {
  console.error('Unable to read existing cart attributes:', existingData); // eslint-disable-line no-console
  return false;
}
    const existingAttributes = existingData?.data?.cart?.attributes || [];

    // Preserve all existing attributes while replacing/adding storefront.
    const attributes = [
      ...existingAttributes.filter((attribute) => attribute.key !== 'storefront'),
      {
        key: 'storefront',
        value: storefront,
      },
    ];

    const response = await fetch(`https://${domain}/api/2025-01/graphql.json`, {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          cartId,
          attributes,
        },
      }),
    });

    const data = await response.json();

    if (data?.errors || data?.data?.cartAttributesUpdate?.userErrors?.length) {
      console.error('Storefront attribute update failed:', data); // eslint-disable-line no-console
      return false;
    }

    return true;
  } catch (err) {
    console.error('Storefront attribute write failed:', err); // eslint-disable-line no-console
    return false;
  }
}

// Main function

async function getCartItemsWithMeta() {

  const cartGid = getCartGidFromLocalStorage();

  if (!cartGid) {

    console.warn('Cart ID (checkoutId) not found.');

    return;

  }

  const query = `

    query GetCartItems($cartId: ID!) {

      cart(id: $cartId) {

        id

        lines(first: 50) {

          edges {

            node {

              id

              quantity

              cost {

                totalAmount {

                  amount

                  currencyCode

                }

              }

              merchandise {

                ... on ProductVariant {

                  id

                  title

                  price {

                    amount

                    currencyCode

                  }

                  product {

                    id

                    title

                    productType

                  }

                }

              }

            }

          }

        }

      }

    }

  `;

  const response = await fetch(`https://${domain}/api/2025-01/graphql.json`, {

    method: 'POST',

    headers: {

      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,

      'Content-Type': 'application/json',

    },

    body: JSON.stringify({

      query,

      variables: {

        cartId: cartGid

      },

    }),

  });

  const data = await response.json();

  const items = data?.data?.cart?.lines?.edges || [];

  let currentTotalCost = 0;

  items.forEach(({ node }) => {

    const variant = node.merchandise;

    const product = variant.product;

    const cost = node.cost.totalAmount;

    const quantity = node.quantity;

    // if(product.productType === "Hardback" || product.productType === "Paperback") {

    currentTotalCost += parseFloat(cost.amount * quantity);

    // }


    if (items.length === 1 && (product.productType === "Audiobook (via Podcast App)" || product.productType === "Audiobook (Via Podcast Player)")) {
      document.getElementById('freeShippingMsg').style.display = 'none';
    }

    else {
      document.getElementById('freeShippingMsg').style.display = 'block';
    }

  });
	var subTotalEl = document.querySelector('.shopify-buy__cart__subtotal__price');
	if(subTotalEl){
  //subTotalEl.innerHTML = currentTotalCost > 0 ? '$'+currentTotalCost.toFixed(2) : '$0.00';
	}
  //document.querySelector('.shopify-buy__cart__subtotal__price').innerHTML = "$" + currentTotalCost.toFixed(2
  return currentTotalCost;

}

async function freeShippingMessage() {

	const freeShippingAmt = 40.00;

  let currentTotalCost = await getCartItemsWithMeta();

  if (!currentTotalCost) {

    console.warn('Unable to calculate freeshipping without cart data.');

    return;

  }

  let freeShippingRemainingAmt = parseFloat(freeShippingAmt) - parseFloat(currentTotalCost);
  freeShippingRemainingAmt = freeShippingRemainingAmt.toFixed(2);

  let freeShippingMsg = '';

  if (freeShippingRemainingAmt > 0.00) {

    freeShippingMsg = `You are $${freeShippingRemainingAmt} away from free shipping!`;

  } else {

    freeShippingMsg = "You've got free shipping!";

  }
  document.getElementById('freeShippingMsg').innerHTML = freeShippingMsg;
}

/**
 * Get campaign params from URL
 * URL example: hachettebookgroup.com/contributor/author-name/?lens=
 * example&utm_source=test1&utm_medium=test2&utm_campaign=test3&
 * utm_content=test4&utm_term=test5#testanchor
 */
function getCampaignData(url) {
  const urlObj = new URL(url);
  return {
    name: urlObj.searchParams.get('utm_campaign'),
    source: urlObj.searchParams.get('utm_source'),
    medium: urlObj.searchParams.get('utm_medium'),
  };
}

/**
 * Set a single elem value of a Braze custom attribute of array 100
 */
function setBrazeSingleElemArrayCustomAttr(attrName, attrVal, sourceStr) {
  if (attrVal) {
    // eslint-disable-next-line no-undef
    braze.getUser().addToCustomAttributeArray(
      attrName,
      attrVal + sourceStr,
    );
  }
}

/**
   * Set Braze custom attributes of array 100
   */
function setBrazeArrayCustomAttr(attrName, attrVal, sourceStr, isAttrValArray = false) {
  if (isAttrValArray) {
    for (let i = 0; i < attrVal.length; i += 1) {
      setBrazeSingleElemArrayCustomAttr(attrName, attrVal[i], sourceStr);
    }
  } else {
    setBrazeSingleElemArrayCustomAttr(attrName, attrVal, sourceStr);
  }
}

function updateCartCount(cart) {
  var total_cart_items = 0;
  var cart_total = 0;
  var cartCount = cart.lineItems.length;
  for (let index = 0; index < cart.lineItems.length; ++index) {
	var item = cart.lineItems[index];
    total_cart_items = cart.lineItems[index].quantity + total_cart_items;
	var price = parseFloat(cart.lineItems[index].variant.price.amount || 0);
    cart_total += price * item.quantity;
  }
  cartCount = total_cart_items;
  document.getElementById('cart-count').textContent = cartCount > 0 ? cartCount : '0';

	var subTotalEl = document.querySelector('.shopify-buy__cart__subtotal__price');
	if(subTotalEl){
  subTotalEl.innerHTML =
    cart_total > 0 ? '$'+cart_total.toFixed(2) : '$0.00';
	}
}

function brazeDataCollection() {
  const campaignData = getCampaignData(window.location.href);
  const hachetteJsonLinkingData = document.querySelector('#hachetteJsonLinkingData');
  const marketerData = JSON.parse(hachetteJsonLinkingData.innerText);
  const sourceStr = ' (atc)';
  setBrazeArrayCustomAttr('ISBNs', marketerData.isbn, sourceStr);
  setBrazeArrayCustomAttr('Referral Titles', marketerData.name, sourceStr);
  setBrazeArrayCustomAttr('Referral Authors', marketerData.author, sourceStr, true);
  setBrazeArrayCustomAttr('Product Formats', marketerData.bookFormat.name, sourceStr);
  setBrazeArrayCustomAttr('Series Name', marketerData.series, sourceStr);
  setBrazeArrayCustomAttr('Publisher', marketerData.publisher.name, sourceStr);
  setBrazeArrayCustomAttr('Campaign Name', campaignData.name, sourceStr);
  setBrazeArrayCustomAttr('Campaign Sources', campaignData.source, sourceStr);
  setBrazeArrayCustomAttr('Campaign Media', campaignData.medium, sourceStr);
  setBrazeArrayCustomAttr('Genre', marketerData.genre, sourceStr, true);
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return '';
}

// get the format of the current title.
function getTitleFormat() {
  let titleFormat = '';
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    const lastEntry = window.dataLayer[window.dataLayer.length - 1];
    if (lastEntry && typeof lastEntry === 'object' && 'format' in lastEntry) {
      titleFormat = lastEntry.format;
      console.log(lastEntry.format);
    }
  }
  return titleFormat;
}

// if cartadd is true in url params, launch cart directly on load.
function launchCartButtonOnLoad() {
  const titleFormat = getTitleFormat();
  addToCartIsbns.forEach(([k, title]) => { // eslint-disable-line no-unused-vars, consistent-return
    let hbgEndpoint = `https://shopifyapi.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-HbgUsa/${title.isbn}`;
    if (hostname === 'hbg-develop.go-vip.co') {
      hbgEndpoint = `https://shopifyapistg.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-HbgUsa/${title.isbn}`;
    }
    return fetch(hbgEndpoint)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return false;
      })
      .then((response) => {
        if (response && (response.inventoryLevel > 0 || response.preorder === 'Y') && response.show) {
          const { productId } = response; // eslint-disable-line no-shadow
          const { isbn } = response;

          if (response.preorder === 'Y') {
            buttonText = 'Preorder';
          } else {
            buttonText = 'Add to Cart';
          }
          ShopifyBuyInit(productId, isbn, freeShippingAmt); // eslint-disable-line no-use-before-define, max-len
        }
        else if (response && titleFormat == 'Audiobook (via Podcast App)') {
          const { productId } = response; // eslint-disable-line no-shadow
          const { isbn } = response;
          buttonText = 'Add to Cart';
          ShopifyBuyInit(productId, isbn, freeShippingAmt); // eslint-disable-line no-use-before-define, max-len
        }
        else if (response && (titleFormat == 'Audiobook Download' || titleFormat == 'ebook')) {
          buttonText = 'Add to Cart';
          ShopifyBuyInit(productId, title.isbn, freeShippingAmt);
          document.getElementById(`product-component-add-to-cart${title.isbn}`).style.display = 'none';
        }
        else if (response && (response.inventoryLevel <= 0 || response.preorder === 'N')) {
          buttonText = 'Add to Cart';
          ShopifyBuyInit(productId, title.isbn, freeShippingAmt);
          document.getElementById(`product-component-add-to-cart${title.isbn}`).style.display = 'none';
        }
      })
      .catch((err) => {
        if (console && console.error) { // eslint-disable-line no-console
          console.error(err); // eslint-disable-line no-console
        }
      });
  });
  return false;
}

function ShopifyBuyInit(productId, isbn, freeShippingAmt) { // eslint-disable-line no-shadow
  const node = document.getElementById(`product-component-add-to-cart${isbn}`);
  let accentColor = '';
  node ? accentColor = getComputedStyle(node).getPropertyValue('--color-accent') : accentColor = '#d93a17'; // eslint-disable-line no-unused-expressions
  const client = ShopifyBuy.buildClient({ // eslint-disable-line no-undef
    domain,
    storefrontAccessToken,
  });
  ShopifyBuy.UI.onReady(client).then((ui) => { // eslint-disable-line no-undef

    const button = document.querySelector('#shopify-cart');
    button.addEventListener('click', (event) => { event.stopPropagation(); ui.openCart() });

    ui.createComponent('product', {
      id: productId,
      node: document.getElementById(`product-component-add-to-cart${isbn}`),
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: {
        product: {
          classes: {
            button: 'title-add-to-cart__button title-add-to-cart__button--fill',
          },
          iframe: false,
          DOMEvents: {
            'click .shopify-buy__btn-wrapper': function () {
              const brazeUserEmail = getCookie('brazeUser');
              if (brazeUserEmail !== '') {
                brazeDataCollection();
              }
            },
          },
          styles: {
            product: {
              '@media (min-width: 601px)': {
                'max-width': 'calc(25% - 20px)',
                'margin-left': '20px',
                'margin-bottom': '50px',
              },
            },
            button: addToCartButton,
            quantityInput: {
              'font-size': '16px',
              'padding-top': '16px',
              'padding-bottom': '16px',
            },
          },
          contents: {
            img: false,
            title: false,
            price: false,
            button: isbn !== '000000000000',
          },
          text: {
            button: buttonText,
          },
        },
        productSet: {
          styles: {
            products: {
              '@media (min-width: 601px)': {
                'margin-left': '-20px',
              },
            },
          },
        },
        modalProduct: {
          contents: {
            img: false,
            imgWithCarousel: true,
            button: false,
            buttonWithQuantity: true,
          },
          styles: {
            product: {
              '@media (min-width: 601px)': {
                'max-width': '100%',
                'margin-left': '0px',
                'margin-bottom': '0px',
              },
            },
            button: {
              'font-weight': 'bold',
              'font-size': '16px',
              'padding-top': '16px',
              'padding-bottom': '16px',
              ':hover': {
                'background-color': '#cb2f21',
              },
              'background-color': '#e13425',
              ':focus': {
                'background-color': '#cb2f21',
              },
            },
            quantityInput: {
              'font-size': '16px',
              'padding-top': '16px',
              'padding-bottom': '16px',
            },
          },
          text: {
            button: buttonText,
          },
        },
        option: {},
        cart: {
          iframe: false,
          events: {
            updateItemQuantity: function (cart) {
              updateCartCount(cart);
            },
            beforeRender() { },
            afterRender: function (cart) {
  //console.log(cart);
  updateCartCount(cart);

              let freeShippingMsg = '';
              jQuery('.shopify-buy__cart__title') // eslint-disable-line no-undef
                .after(`<div id="freeShippingMsg">${freeShippingMsg}</div>`);
              freeShippingMessage();
              // Set maxlength on the order notes textarea
              const noteTextarea = document.querySelector('.shopify-buy__cart__note__text-area');
              if (noteTextarea) {
                noteTextarea.setAttribute('maxlength', '150');
              }
			    if (!window.__pendingATC || !cart?.lineItems?.length) return;

			  // Assume the last item is the newly added one
			  const item = cart.lineItems[cart.lineItems.length - 1];

			  // Prevent duplicate fires
			  if (item.__klaviyoTracked) return;
			  item.__klaviyoTracked = true;

			  fireKlaviyoATC(item, cart);

			  // Clear intent
			  window.__pendingATC = null;
            },
          },
          text: {
            title: 'Shopping Cart',
            total: 'Subtotal',
            button: 'Checkout',
            noteDescription: 'Add an optional Gift Message (150 character limit)',
          },
          popup: false,
          contents: {
            note: true,
          },
          styles: {
            button: {
              'background-color': accentColor,
              'border-radius': '9999px',
              'font-size': '15px',
              'font-weight': '700',
              'letter-spacing': 'unset',
              'line-height': '1.2',
              padding: '12px 17px',
              ':hover': {
                'background-color': '#000000',
              },
              ':focus': {
                'background-color': '#000000',
              },
            },
          },
        },
        toggle: {
          styles: {
            toggle: {
              'display': 'none',
              /*
              'background-color': accentColor,
              'font-weight': '700',
              ':hover': {
                'background-color': '#000000',
                */
            },
          },
        },
      },
    });
  });

}

if (addToCartIsbns.length === 0) {
  ShopifyBuyInit(productId, '000000000000', freeShippingAmt);
  addToCartButton = {
    'font-size': '13px',
    'padding-top': '14.5px',
    'padding-bottom': '14.5px',
    'border-radius': '0px',
    'padding-left': '0px',
    'padding-right': '0px',
  };
  buttonText = '';
  //launchCartButtonOnLoad();
} else {
  addToCartButton = {
    'font-weight': 'bold',
    'font-size': '16px',
    'padding-top': '16px',
    'padding-bottom': '16px',
    ':hover': {
      'background-color': '#cb2f21',
    },
    'background-color': '#e13425',
    ':focus': {
      'background-color': '#cb2f21',
    },
  };
  buttonText = 'Add to Cart';
  //launchCartButtonOnLoad();
}

async function getProductByISBN(isbn) {
  const query = `
	{
	  products(first: 1, query: "metafield:books.isbn:${isbn}") {
		edges {
		  node {
			id
			title
			handle
			description
			publicationDate: metafield(namespace: "custom", key: "publication_date") { value }
			variants(first: 10) {
			  edges {
				node {
				  id
				  sku
				  availableForSale
				}
			  }
			}
		  }
		}
	  }
	}
  `;

  const response = await fetch(`https://${domain}/api/2025-10/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontAccessToken
    },
    body: JSON.stringify({ query })
  });

  const data = await response.json();
  return data;
}

function isPreorder(publicationDate) {
  if (!publicationDate) return false;

  const pub = new Date(publicationDate);
  const now = new Date();
  const diffDays = (pub - now) / 86400000;

  return diffDays > 0 && diffDays <= 180;
}

function isBeyondPreorder(publicationDate) {
  if (!publicationDate) return false;

  const pub = new Date(publicationDate);
  const now = new Date();
  const diffDays = (pub - now) / 86400000;

  return diffDays > 180;
}

async function atcIsbnApi(rawData = []) {

    if (!rawData.length) return {
        success: false,
        data: {}
    };

    const isbns = [];

    rawData.forEach(item => {
        const data = item[1];
        if (data?.isbn) isbns.push(data.isbn);
    });

    const uniqueIsbns = [...new Set(isbns)];

    if (!uniqueIsbns.length) return {
        success: false,
        data: {}
    };

    try {

        const res = await fetch('/wp-json/isbns/v1/isbn-batch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                isbns: uniqueIsbns
            })
        });

        // API error (500, 404, etc.)
        if (!res.ok) {
            console.error('API error status:', res.status);
            return {
                success: false,
                data: {}
            };
        }

        // Handle empty body safely
        const text = await res.text();

        if (!text) {
            console.warn('Empty API response');
            return {
                success: false,
                data: {}
            };
        }

        const json = JSON.parse(text);

        return json;

    } catch (e) {

        console.error('ISBN API error:', e);

        return {
            success: false,
            data: {}
        }; // always return safe shape
    }
}

async function launchAddToCartButton(){
	const  titleFormat = getTitleFormat();
	const atcApiResData = await atcIsbnApi(addToCartIsbns);
	console.log(atcApiResData);

	for (const [k, title] of addToCartIsbns) {
		let isbn = title.isbn;

		const strIsbn = String(title.isbn);
		const disableAtc = atcApiResData.data?.[strIsbn]?.disableAtc ?? false;
		if(disableAtc === true){
			continue;
		}

		let responseData = await getProductByISBN(isbn);

		// Extract product ID and publication date
		const productNode = responseData?.data?.products?.edges?.[0]?.node ?? {};
		const variantNode = productNode?.variants?.edges?.[0]?.node ?? {};
		const productId = (productNode.id ?? "").replace("gid://shopify/Product/", "");
		const publicationDate = productNode?.publicationDate?.value ?? null;
		const availableForSale = variantNode?.availableForSale ?? false;

		if(availableForSale && !isBeyondPreorder(publicationDate)) {
			if(isPreorder(publicationDate)===true){
				buttonText = 'Preorder';
			} else {
				buttonText = 'Add to Cart';
			}
			ShopifyBuyInit(productId, isbn, freeShippingAmt);
		} else if(availableForSale === false || isPreorder(publicationDate) === false) {
			buttonText = 'Add to Cart';
			ShopifyBuyInit(productId, isbn, freeShippingAmt);
			document.getElementById(`product-component-add-to-cart${isbn}`).style.display = 'none';
		}
	}
}

if (addToCartIsbns.length) {
  launchAddToCartButton();
}
function fireKlaviyoATC(item, cart) {
  window._learnq = window._learnq || [];

  const product = {
    "$event_id": `${cart.id}-${item.id}`, // dedupe-safe

    ProductName: window.__pendingATC.ProductName,
    ISBN: window.__pendingATC.ISBN,
    Author: window.__pendingATC.Author,
    Publisher: window.__pendingATC.Publisher,
    Genre: window.__pendingATC.Genre,

    Quantity: item.quantity,
    VariantID: item.variant?.id,
    CartID: cart.id,

    Price: window.__pendingATC.Price,
    Currency: window.__pendingATC.Currency,
    ImageURL: window.__pendingATC.ImageURL,
    ProductURL: window.__pendingATC.ProductURL,
    Locale: window.__pendingATC.Locale
  };

  _learnq.push(["track", "Added to Cart", product]);
}

document.addEventListener(
  "click",
  function (e) {
    const atcBtn = e.target.closest(".title-add-to-cart__button");
    if (!atcBtn) return;

    const jsonEl = document.querySelector("#hachetteJsonLinkingData");
    if (!jsonEl) return;

    const data = JSON.parse(jsonEl.innerText);

    const authors = Array.isArray(data.author)
      ? data.author.map(a => a.name).join(", ")
      : "";

    const genres = Array.isArray(data.genre)
      ? data.genre.join(", ")
      : "";

    const offer = Array.isArray(data.offers) ? data.offers[0] : data.offers;

    // STORE INTENT (do NOT fire yet)
    window.__pendingATC = {
      ProductName: data.name,
      ISBN: data.isbn,
      Author: authors,
      Publisher: data.publisher?.name || "",
      Genre: genres,
      Price: offer?.price || null,
      Currency: offer?.priceCurrency || "USD",
      ImageURL: Array.isArray(data.image) ? data.image[0] : "",
      ProductURL: offer?.url || window.location.href,
      Locale: navigator.language || "en-US"
    };

  },
  true
);

function stampStorefrontAfterClick(retries) {
  if (retries === undefined) { retries = 6; }
  const cartId = getCartGidFromLocalStorage();
  if (cartId) {
    if (!window.__storefrontStamped) {
      updateStorefrontCartAttribute(cartId).then((success) => {
        if (success) { window.__storefrontStamped = true; }
      });
    }
    return;
  }
  if (retries > 0) {
    setTimeout(() => stampStorefrontAfterClick(retries - 1), 300);
  }
}

document.addEventListener('click', function (e) {
  if (!e.target.closest('.title-add-to-cart__button')) return;
  stampStorefrontAfterClick();
}, true);
